import { render, staticRenderFns } from "./PayrollDetails.vue?vue&type=template&id=324ee202&"
import script from "./PayrollDetails.vue?vue&type=script&lang=js&"
export * from "./PayrollDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports